module.exports = __webpack_public_path__ + "img/700_Fake-profile.06da474b.png";